import React from "react";
import Layout from "components/structure/Layout";
import ImportList from "../Common/ImportList";

const ImportSubGrower = () => {
  return (
    <Layout title={"Import Sub Grower"}>
      <ImportList entityName="ImportSubGrower" displayName="Import Sub Grower" />
    </Layout>
  );
};

export default ImportSubGrower;
